import {
	HubSpotAuthType,
	HubSpotConnectionDetails,
} from '../../interfaces/hubspot/hubspot-connection-details';
import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a HubspotSaveAssociations task.
 * Creates default associations between two HubSpot object types using IDs resolved
 * from each flow record. Both ID fields support full expression syntax.
 */
export class HubSpotSaveAssociationConfig
	extends DestinationTaskConfigBase
	implements HubSpotConnectionDetails
{
	/** HubSpot private app access token. Supports expression syntax. Leave blank to use iHub credential store. @default '' */
	accessToken = '';
	/** The FROM object type (e.g. 'Contacts'). Passed directly to the HubSpot associations API. @default 'Contacts' */
	hubSpotObjectType = 'Contacts';
	/** Expression or field path that resolves to the HubSpot ID of the FROM object for each record. @default '' */
	fromObjectIDField = '';
	/** The TO object type (e.g. 'Companies'). Passed directly to the HubSpot associations API. @default 'Companies' */
	toObjectType = 'Companies';
	/** Expression or field path that resolves to the HubSpot ID of the TO object for each record. @default '' */
	toObjectIDField = '';
	/** When true, the access token is read from a flow variable instead of the accessToken field. */
	useVariableToken?: boolean;
	/** Chooses between a static/variable Private App token vs a reusable Web App OAuth connection. @default HubSpotAuthType.PrivateAppToken */
	authType: HubSpotAuthType = HubSpotAuthType.PrivateAppToken;
	/** Selected `OAuthConnectionConfig.id` (provider=HubSpot). WebApp auth only. */
	connectionID?: string;

	constructor(init?: Partial<HubSpotSaveAssociationConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
